import localStorage from 'r/utils/localStorage';
import {AUTHTOKEN as localStorageKey} from '../KEYS';

const defaultValue = null;

export default class StoredAuth {
  static get() {
    const stored = JSON.parse(localStorage.getItem(localStorageKey)) || defaultValue;

    if (stored && typeof stored === 'object' && !Array.isArray(stored)) {
      return stored.default || null;
    }

    return stored;
  }

  static set(value) {
    localStorage.setItem(localStorageKey, JSON.stringify(value));
  }

  static getAll() {
    return JSON.parse(localStorage.getItem(localStorageKey)) || defaultValue;
  }
}
